import React, { useEffect, useState } from 'react';

//*MUI
import {
  Box,
  Divider,
  TableBody,
  TableRow,
  TableFooter,
  TablePagination,
  AccordionSummary,
  Table,
  TableHead,
  Accordion,
  AccordionDetails,
  TableCell,
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

//*Redux
import { useSelector } from 'react-redux';

//*files
import cssClasses from './InventoryDetails.module.css';
import { getProjectByTeamWise } from '../../../Services/AssignProject';
import { FetchInventoryFromServer } from '../../../Services/Dashboard';
import _, { groupBy, uniqBy } from 'lodash';
import EmptyState from '../../../Assets/Images/Common/noProjectFound.svg';
import ViewInventoryDetails from '../../../Modals/ViewInventoryDetails/ViewInventoryDetails';
import { useNavigate } from 'react-router-dom';
import MultiSelectDropDown from '../../../Subcomponents/MultiSelectDropDown/MultiSelectDropDown';
import { dismissLoader, presentLoader } from '../../../Services/loader';

function InventoryDetails() {
  let loggedInUser = {};
  const teamIds = JSON.parse(localStorage.getItem('teamIds'));
  const navigate = useNavigate();
  loggedInUser = useSelector((state) => state.Auth.user);
  // console.log(loggedInUser);

  const [projectList, setProjectList] = useState([]);
  const [inventoryRows, setInventoryRows] = useState([]);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(11);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedProject, setSelectedProject] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState('');
  const [ViewDetails, setViewDetails] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [NoInventoryFound, setNoInventoryFound] = useState(null);
  const [selectDates, setSelectDates] = useState([
    {
      label: 'StartDate',
      value: window.location.search.split('?')[2].split('=')[1],
    },
    {
      label: 'EndDate',
      value: window.location.search.split('?')[3].split('=')[1],
    },
  ]);

  useEffect(() => {
    const fetchProjects = async () => {
      const projectArr = await getProjectByTeamWise(teamIds);
      const arr = [];
      uniqBy(projectArr.data, 'projectId.projectId').forEach((v) => {
        arr.push({
          name: v?.projectId?.projectName,
          id: v?.projectId?.projectId,
        });
      });
      const url_arr1 = window.location.search
        .split('?')[1]
        .split('=')[1]
        .split(',')
        .forEach((em) => {
          const url_val = arr.find((f) => f.name === decodeURIComponent(em));
          selectedProject.push(url_val === undefined ? [] : url_val);
        });
      setProjectList(arr);
      InventoryFromServer(
        0,
        false,
        teamIds,
        selectedProject.length > 0
          ? selectedProject.map((m) => {
              return m.id;
            })
          : [],
        null,
        selectDates
      );
    };
    fetchProjects();
  }, []);

  function InventoryFromServer(
    pageNumber,
    merge,
    teamIds,
    projectId,
    userId,
    selectDates
  ) {
    presentLoader();
    FetchInventoryFromServer(
      pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1,
      teamIds,
      projectId,
      userId,
      selectDates
    )
      .then((UsersResp) => {
        console.log('UsersResp', UsersResp);
        const filteredData = groupBy(UsersResp.data, 'projectId');
        const MappedDetails = [];
        Object.values(filteredData).forEach((em) => {
          const groupByWingId = groupBy(em, 'wingId.wingId');


          Object.values(groupByWingId).forEach((elm) => {
            const Mapped_Details = Object.values(elm)?.map((val, index) => {
              let details = groupBy(elm, 'inventoryTypeId.inventoryTypeId');
              let firstRow = Object.values(details).splice(0, 1);
              let remainingRows = Object.values(details).splice(
                1,
                Object.values(details).length
              );
              
              return {
                details,
                projectName: elm[0]?.wingId?.projectId?.projectName,
                firstRow,
                remainingRows,
                wingName: elm[0]?.wingId.wingName,
                id: _.uniqueId(index),
              };
            });
            // console.log('data', Mapped_Details);
            MappedDetails.push(Mapped_Details);
          });

          if (UsersResp.data.length > 0) {
            setNoInventoryFound(true);
          } else {
            setNoInventoryFound(false);
          }

          if (merge) {
            setInventoryRows((pre) => pre, MappedDetails);
          } else {
            setInventoryRows(MappedDetails);
          }
          dismissLoader();
        });
      })
      .catch((err) => {
        console.error('FetchInventoryFromServer', err);
        dismissLoader();
      });
  }

  function pageChanged(e) {
    // console.log(e);
    setPageMaintain(e);
    if (pageNumber < e) {
      setPageNumber(e);
    }
  }

  function getMoreData() {}

  return (
    <>
      <Box className={cssClasses.Container}>
        <Box mb={1}>
          <Box className={cssClasses.SubContainer}>
            <Box className={cssClasses.DivContainer}>
              <Box className={cssClasses.HeaderTitle}>Inventory</Box>
            </Box>
          </Box>
        </Box>

        <Divider />

        <Box margin={'1rem 0'}></Box>

        <div className={cssClasses.filtersDiv}>
          <div className={cssClasses.filtersDivA}>
            <Box>
              <div className={cssClasses.SubTitle}>Select Project:</div>
              <MultiSelectDropDown
                list={projectList}
                value={selectedProject}
                style={{
                  background: '#F2F4F7',
                  color: 'rgb(102, 112, 133)',
                  minWidth: '250px',
                  borderRadius: '4rem',
                  width: '350px',
                }}
                helperText={''}
                handleChange={(e) => {
                  const value = e?.target?.value;
                  // console.log('value', value);
                  if (value !== '') {
                    if (value[value.length - 1] === 'all') {
                      setSelectedProject(
                        selectedProject.length === projectList.length
                          ? []
                          : projectList
                      );
                      InventoryFromServer(
                        0,
                        false,
                        teamIds,
                        [],
                        null,
                        selectDates
                      );
                      return;
                    }
                    setSelectedProject(value);
                    InventoryFromServer(
                      0,
                      false,
                      teamIds,
                      value.map((m) => {
                        return m.id;
                      }),
                      null,
                      selectDates
                    );
                    navigate(
                      `/home/Dashboard/Inventory?projectName=${value
                        .map((m) => {
                          return m.name;
                        })
                        .toString()}?startDate=${
                        selectDates[0]?.value !== '' ? selectDates[0]?.value : 0
                      }?endDate=${
                        selectDates[1]?.value !== '' ? selectDates[1]?.value : 0
                      }`
                    );
                  }
                }}
                flag={true}
              />
            </Box>
          </div>
        </div>
        {NoInventoryFound === true && (
          <React.Fragment>
            <Box sx={{ margin: 1 }}>
              <Table
                size='large'
                aria-label='purchases'
                className={cssClasses.tableBorder}
              >
                <TableHead className={cssClasses.tableHead} stickyHeader>
                  <TableRow className={cssClasses.tableRow1}>
                    <TableCell className={cssClasses.innerTitle}>
                      <Box
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          // justifyContent: 'space-between',
                          // width: "100%",
                        }}
                      >
                        <div style={{ width: '28rem' }}>Project </div>
                        <div style={{ width: '20rem' }}>Wing </div>
                        <div style={{ width: '17rem' }}>Product </div>
                        <div style={{ width: '15rem' }}>Total Count </div>
                        <div style={{ width: '10rem' }}>Sold </div>
                        <div style={{ width: '10rem' }}>UnSold </div>
                        <div style={{ width: '10rem' }}>View</div>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <div style={{ overflow: 'auto', height: '280px' }}>
                  <TableBody style={{ tableLayout: 'fixed' }}>
                    {inventoryRows &&
                      inventoryRows.map((elm, index) => (
                        <TableRow key={index}>
                          <Accordion
                            sx={{
                              '& .MuiPaper-root': {
                                color: 'darkslategray',
                                backgroundColor: '#E4FAF4',
                                borderRadius: '0.6rem',
                                boxShadow: 'none',
                              },
                              boxShadow: 'none',
                              borderBottom: '3px solid #EAECF0',
                            }}
                            expanded={selectedRowId === elm[0].id}
                          >
                            <AccordionSummary
                              expandIcon={
                                Object.values(elm[0]?.remainingRows).length >
                                0 ? (
                                  <>
                                    {selectedRowId === elm[0].id ? (
                                      <RemoveCircleOutlineIcon
                                        sx={{
                                          color: '#1570EF',
                                          height: '20px',
                                          width: '20px',
                                        }}
                                        onClick={() => setSelectedRowId(-1)}
                                      />
                                    ) : (
                                      <AddCircleOutlineIcon
                                        sx={{
                                          color: '#1570EF',
                                          height: '20px',
                                          width: '20px',
                                        }}
                                        onClick={() =>
                                          setSelectedRowId(elm[0].id)
                                        }
                                      />
                                    )}
                                  </>
                                ) : (
                                  <div></div>
                                )
                              }
                              aria-controls='panel1a-content'
                              id='panel1a-header'
                            >
                              <Box
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  // justifyContent: 'space-between',
                                  // width: '100%',
                                }}
                              >
                                <div
                                  className={cssClasses.FirstTitle}
                                  style={{ width: '28rem' }}
                                >
                                  {elm[0]?.projectName}
                                </div>
                                <div
                                  className={cssClasses.FirstTitle}
                                  style={{ width: '20rem' }}
                                >
                                  {elm[0]?.wingName}
                                </div>
                                <div
                                  className={cssClasses.innerTitle}
                                  style={{ width: '17rem' }}
                                >
                                  {
                                    elm[0]?.firstRow[0][0]?.inventoryTypeId
                                      ?.type
                                  }
                                </div>
                                <div
                                  className={cssClasses.innerTitle}
                                  style={{ width: '15rem' }}
                                >
                                  {elm[0]?.firstRow[0]?.length}
                                </div>
                                <div
                                  className={cssClasses.innerTitle}
                                  style={{ width: '10rem' }}
                                >
                                  {
                                    elm[0]?.firstRow[0]?.filter(
                                      (f) =>
                                        (f?.inventoryStatusId?.status ===
                                          'Kyc Pending' ||
                                        f?.inventoryStatusId?.status ===
                                          'Preselected' ||
                                        f?.inventoryStatusId?.status ===
                                          'Sold' ||
                                        f?.inventoryStatusId?.status ===
                                          'Payment Pending' ||
                                        f?.inventoryStatusId?.status ===
                                          'Kyc Done' ) && f?.leadId !== null
                                    ).length
                                  }
                                </div>
                                <div
                                  className={cssClasses.innerTitle}
                                  style={{ width: '10rem' }}
                                >
                                  {
                                    elm[0]?.firstRow[0]?.filter(
                                      (f) =>
                                        (f?.inventoryStatusId?.status ===
                                          'Available' ||
                                        f?.inventoryStatusId?.status ===
                                          'On Hold' ||
                                        f?.inventoryStatusId?.status ===
                                          'Reserved' ||
                                        f?.inventoryStatusId?.status ===
                                          'Locked' ) && f?.leadId === null
                                    ).length
                                  }
                                </div>
                                <div
                                  className={cssClasses.innerTitle}
                                  style={{
                                    cursor: 'pointer',
                                    textDecorationLine: 'underline',
                                    width: '10rem',
                                  }}
                                  onClick={() => {
                                    setViewDetails(elm[0]?.firstRow[0]);
                                    setOpenView(true);
                                  }}
                                >
                                  View Details
                                </div>
                              </Box>
                            </AccordionSummary>

                            <AccordionDetails sx={{ padding: '0 !important' }}>
                              {Object.values(elm[0]?.remainingRows).length >
                                0 && (
                                <>
                                  {Object.values(elm[0]?.remainingRows).map(
                                    (m, i) => (
                                      <>
                                        <Box
                                          style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            margin: '3rem',
                                          }}
                                        >
                                          <div
                                            className={cssClasses.FirstTitle}
                                            style={{ width: '27rem' }}
                                          >
                                            {''}
                                          </div>
                                          <div
                                            className={cssClasses.FirstTitle}
                                            style={{ width: '20rem' }}
                                          >
                                            {''}
                                          </div>
                                          <div
                                            className={cssClasses.innerTitle}
                                            style={{ width: '17rem' }}
                                          >
                                            {m[0]?.inventoryTypeId?.type}
                                          </div>
                                          <div
                                            className={cssClasses.innerTitle}
                                            style={{ width: '15rem' }}
                                          >
                                            {m?.length}
                                          </div>
                                          <div
                                            className={cssClasses.innerTitle}
                                            style={{ width: '10rem' }}
                                          >
                                            {
                                              m?.filter(
                                                (f) =>
                                                  (f?.inventoryStatusId
                                                    ?.status ===
                                                    'Kyc Pending' ||
                                                  f?.inventoryStatusId
                                                    ?.status ===
                                                    'Preselected' ||
                                                  f?.inventoryStatusId
                                                    ?.status === 'Sold' ||
                                                  f?.inventoryStatusId
                                                    ?.status ===
                                                    'Payment Pending' ||
                                                  f?.inventoryStatusId
                                                    ?.status === 'Kyc Done') && f?.leadId !== null
                                              ).length
                                            }
                                          </div>
                                          <div
                                            className={cssClasses.innerTitle}
                                            style={{ width: '10rem' }}
                                          >
                                            {
                                              m?.filter(
                                                (f) =>
                                                  (f?.inventoryStatusId
                                                    ?.status === 'Available' ||
                                                  f?.inventoryStatusId
                                                    ?.status === 'On Hold' ||
                                                  f?.inventoryStatusId
                                                    ?.status === 'Reserved' ||
                                                  f?.inventoryStatusId
                                                    ?.status === 'Locked') && f?.leadId === null
                                              ).length
                                            }
                                          </div>
                                          <div
                                            className={cssClasses.innerTitle}
                                            style={{
                                              cursor: 'pointer',
                                              textDecorationLine: 'underline',
                                              width: '10rem',
                                            }}
                                            onClick={() => {
                                              setViewDetails(m);
                                              setOpenView(true);
                                            }}
                                          >
                                            View Details
                                          </div>
                                        </Box>
                                      </>
                                    )
                                  )}
                                </>
                              )}
                            </AccordionDetails>
                          </Accordion>
                        </TableRow>
                      ))}
                  </TableBody>
                </div>

                <TableFooter className={cssClasses.tableFooter}>
                  <TableRow className={cssClasses.tableRow1}>
                    <TableCell className={cssClasses.innerTitle}>
                      <Box
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          padding: '1rem',
                        }}
                      ></Box>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </Box>
          </React.Fragment>
        )}

        {openView && (
          <ViewInventoryDetails
            open={openView}
            handleClose={() => setOpenView(false)}
            data={ViewDetails}
          />
        )}

        {NoInventoryFound === false && (
          <Box sx={{ height: '100%' }}>
            <Box className={cssClasses.noDataMsg}>
              <Box className={cssClasses.emptyIcon}>
                <img src={EmptyState} alt='No Wings' />
              </Box>
              <Box className={cssClasses.emptyTitle}>No Inventory found</Box>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
}

export default InventoryDetails;
